// src/main.js
import '@babel/polyfill';
import 'whatwg-fetch';
import Vue from 'vue';
import VueRouter from 'vue-router';
import Amplify, * as AmplifyModules from 'aws-amplify';
import { AmplifyPlugin } from 'aws-amplify-vue';
import ToggleButton from 'vue-js-toggle-button'
import BootstrapVue from 'bootstrap-vue';
import VueMeta from 'vue-meta';

import App from './App';
import router from './routes/router';
import config from './aws-exports';
import './styles/global.scss';
import store from './store/store';

import ProfileForm from '@/components/ProfileForm';

// Silence Logs in Production
if (process.env.NODE_ENV !== 'development') {
  console.log = () => {};
}

Vue.component('profile-form', ProfileForm);

Amplify.configure(config)
Vue.use(VueRouter)
Vue.use(AmplifyPlugin, AmplifyModules)
Vue.use(BootstrapVue)
Vue.use(ToggleButton)
Vue.config.productionTip = false
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

new Vue({
  render: h => h(App),
  store,
  router
}).$mount('#app')
